// extracted by mini-css-extract-plugin
export var buttonContainer = "_7o-1";
export var fontSizeSelect = "_7o-3";
export var formatSelect = "_7o-2";
export var formats = "_7o-4";
export var hidden = "_7o-5";
export var icon = "_7o-6";
export var select = "_7o-0";